import './style.scss';

document.addEventListener('DOMContentLoaded', function () {
    const faqTriggers = document.querySelectorAll('.lode--faq-item');

    faqTriggers.forEach(trigger => {
        trigger.addEventListener('mousedown', function () {
            const content = trigger.querySelector('.lode--faq-content');
            const isExpanded = this.getAttribute('aria-expanded') === 'true';

            this.setAttribute('aria-expanded', !isExpanded);
            content.hidden = isExpanded;

            if (isExpanded) {
                this.classList.add('active');
            } else {
                this.classList.remove('active');
            }
        });
    });
});